<template>
  <div class="float">
    <ul ref="ul" :style="{ right: right }">
      <li>
        <a class="btn-1" href="#" @click.capture="funclick">返回顶部</a>
      </li>

      <li>
        <a class="looyuLink btn-2">人工客服</a>
      </li>
      <li>
        <a href="tel:4001012233" class="btn-3">咨询电话</a>
      </li>
      <li @click="funclick">
        <a href="http://m.eicchannel.com/" class="btn-4">启德课堂</a>
      </li>
    </ul>

    <div class="video" v-if="isShow">
      <iframe src="http://www.eicchannel.com/special/gz_m.html" frameborder="0" style="padding-top: 0.8rem"></iframe>
      <img src="@/assets/images/video_close.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      right: "-0.4rem",
      rightShow: false,
      clickNum: 0,
      isShow: false,
    };
  },
  computed: {},
  methods: {
    funclick() {},
  },
  mounted() {
    this.$refs.ul.addEventListener(
      "click",
      (e) => {
        // ++this.clickNum
        ++this.clickNum;
        if (this.clickNum % 2 != 0) {
          this.right = "0.2rem";
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      },
      true
    );

    window.addEventListener(
      "scroll",
      () => {
        this.right = "-0.4rem";
      },
      true
    );
  },
  created() {},
};
</script>

<style>
.video {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
  background: #000;
}
.video iframe {
  width: 100%;
  height: 100%;
}
.video img {
  position: absolute;
  left: 0.15rem;
  top: 0.15rem;
  width: 0.5rem;
  height: 0.5rem;
}
.float {
}
.float ul {
  position: fixed;
  z-index: 999;
  top: 30%;
  margin: auto;
  transition: all 0.3s;
}
.float ul li {
  margin-bottom: 0.17rem;
}
.float ul li a {
  display: block;
  width: 1rem;
  height: 0.9rem;
  font-size: 0;
}
.float ul li a.btn-1 {
  background: url(~@/assets/images/right_btn1.png) no-repeat;
  background-size: 100% 100%;
}
.float ul li a.btn-2 {
  background: url(~@/assets/images/right_btn2.png) no-repeat;
  background-size: 100% 100%;
}
.float ul li a.btn-3 {
  background: url(~@/assets/images/right_btn4.png) no-repeat;
  background-size: 100% 100%;
}
.float ul li a.btn-4 {
  background: url(~@/assets/images/right_btn3.png) no-repeat;
  background-size: 100% 100%;
}

</style>
